import { render } from "./chCookieBanner.vue?vue&type=template&id=c4b63a58"
import script from "./chCookieBanner.vue?vue&type=script&lang=js"
export * from "./chCookieBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__